import script from "./SwitchIconButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./SwitchIconButton.vue?vue&type=script&setup=true&lang=ts"

import "./SwitchIconButton.vue?vue&type=style&index=0&id=e69de09e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e69de09e"]])

export default __exports__